import $ from "jquery";

const $document = $(document);

$(function () {
  $document.on("click", ".cookies-modal-trigger", function () {
    const $targetModal = $($(this).data("target"));
    openModal($targetModal);
  });
  $document.on("click", ".cookies-modal", function () {
    closeModal($(this));
  });
  $document.on(
    "click",
    ".cookies-modal__close,.cookies-modal-close",
    function () {
      const $targetModal = $(this).closest(".cookies-modal");
      closeModal($targetModal);
    }
  );
  $document.on("keydown", function (event) {
    const $targetModal = $document.find(".cookies-modal.active");
    if (event.key === "Escape") {
      closeModal($targetModal);
    }
  });
  $document.on("click", ".cookies-modal__content > *", function (event) {
    event.stopImmediatePropagation();
  });
});

export function openModal(targetModal) {
  if (targetModal !== undefined) {
    if (!targetModal.hasClass("active")) {
      targetModal.trigger("cookies-modal:opening");
      targetModal.addClass("active").one("transitionend", function () {
        targetModal.trigger("cookies-modal:opened");
      });
    }
  }
}

export function closeModal(targetModal) {
  if (targetModal !== undefined) {
    if (targetModal.hasClass("active")) {
      targetModal.trigger("cookies-modal:closing");
      targetModal.removeClass("active").one("transitionend", function () {
        targetModal.trigger("cookies-modal:closed");
      });
    }
  }
}
